import styled from 'styled-components';

const LoginWrapper = styled.div`
    position: relative;
`;

const LoginOverlay = styled.div`
    position: fixed;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: var(--primaryBlue);
`;

const LoginFooter = styled.div`
    margin-top: auto;

    svg {
        margin-left: 8px;
    }
`;

const LoginBody = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    width: 620px;
    min-height: 600px;
    z-index: 10;
    background-color: var(--white);
    box-shadow: 0 0 4px 2px rgba(var(--black) 0.1);
    border-radius: 4px;
    margin: 0 auto;
    padding: 75px 80px 16px;

    .landingPageIcon {
        margin: 35px auto 0;
    }

    h1 {
        font-weight: 630;
        margin-top: 15px;
        margin-bottom: 50px;
        font-size: 32px
    }

    h2 {
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 22px;
    }
`;

const LoginForm = styled.div`
    width: 240px;
    margin: 20px auto;

    > div {
        width: 100%;
        margin: 4px 0;
    }
`;

const LoginContent = styled.div`
    margin-top: auto;
    margin-bottom: auto;
`;

const ActionsWrapper = styled.div`
    padding-top: 20px;
    position: relative;
    
    >div {
        position: absolute;
        z-index: 1;
        width: 100%;
        margin: 0;
        background: #fff;
        padding: 10px;
    }
`;

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
`;

const LandingPageFooter = styled.section`
    position: relative;
    display: flex;
    justify-content: center;
    text-align: center; 
    z-index: 10;

    > a {
        color: white;
        margin: calc((2 / 3) * (100vh - 600px) / 2) 21px 0;
    }
`;

export default {
    LoginWrapper,
    LoginOverlay,
    LoginForm,
    LoginBody,
    ActionsWrapper,
    PageContainer,
    LoginFooter,
    LoginContent,
    LandingPageFooter
};